 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		25: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"npm.quill","2":"npm.react-dom","3":"npm.react-quill","7":"npm.babel","8":"npm.emoji-picker-react","9":"npm.react-dd-menu","10":"npm.react-papaparse","11":"npm.react-player","12":"npm.readable-stream","17":"npm.canvg","18":"npm.create-react-class","19":"npm.d3-scale","20":"npm.dompurify","21":"npm.react-querybuilder","22":"npm.react-smooth","23":"npm.react-sortable-hoc","24":"npm.recharts"}[chunkId]||chunkId) + "." + {"1":"d603068026ac191700d3","2":"0e7c69ea3084e053b6a2","3":"178c407a689716bef2cb","4":"bd6e356416e16e6e78b4","5":"608b5148b0d7d54e62e4","6":"b60353fe52070d422928","7":"f53aa471d5fd48bd2f25","8":"60e8a3c3d4500ffdf1b4","9":"091a8b7bab5aa73ee718","10":"c474607377a9ed04d054","11":"f51a5adafe29531e67fc","12":"ca130e96103a05dd5f36","13":"24b85404fcc0339df49d","14":"1b625f3378a9db60bbef","17":"23abe43bec6ee4a4ccb2","18":"4d17f9c1570e999f6e9d","19":"f35c3202dd6e26f0654c","20":"01f21c1fa07c5237801c","21":"5958492da9d50145e70e","22":"8bdea132b417f5b65922","23":"3176a1410e1709acb014","24":"608993608670a53be41c","26":"f67ccd6d759f4b4d4df9","27":"67a64ebaceb464f09121","28":"3d5e0bf8304199951766","29":"f73f3bb8e234b20c5052","30":"4c00d7a79092dcbccb30","31":"1e10667436c52b5fa241","32":"87b62b4a5b7fed0a9e6c","33":"faa46c7f480fe94bc565","34":"486a2f18156ff7670cb1","35":"ee3ec899926f9c2c2950","36":"5aa2ab3f846ccf5377a6","37":"b2ad32238babac60aff5","38":"0a3f458eb7a475eec481","39":"a0f22d3416e496ea59b2","40":"ac5ef6821453b2cb09a0","41":"5746c1ff2106f55a2827","42":"b35b95e8ada96fa1d5b8","43":"84775e9e31f691c70f64","44":"e9ba2622d200d6d38c9e","45":"d00188386b8b1562960f","46":"17f5b79c92fb204e5843","47":"c5d566e45771840f42ad","48":"624edaf79612b85e3dd2","49":"d96057c853a9d8ecf240","50":"d27e40dd829f78bb2596","51":"4e0c3ceb3a26e9db433c","52":"4ef14fd3cf4b79490fcf","53":"1bf3caa4f7a80721be53","54":"4f337875ce92f5a46932","55":"6479f6117fc0fd71d1ae","56":"7ef8955f0659c9c5fb64","57":"36f54b95a6b6da60ae43","58":"3eaf269be57c2c3b4410","59":"60a943f16c00119d6e55","60":"b7260a38bc20a967ca6d","61":"e7d7ce16c20ab4052ad4","62":"5865f0210e83e747be1d","63":"d5d5de6636da06d42dad","64":"4e24d50003e9a43590f8","65":"5572e8031711275e6e03","66":"bb2562c2a236a5c5c2e0","67":"c2667908b848bb8c1f46","68":"320b5f7b1b2b0ba98cc7","69":"2739f6e6051514d54bbd","70":"0f3f52d7f88cfc5a35b3","71":"9256797707a9bc53fe7f","72":"9c3cbf454a8886920c66","73":"031aeb47afbd29e56c45","74":"c6611dc4c75d308db71a","75":"f4391bad6acec358541e","76":"0b1a05a9a31d5045d1c1","77":"a5c104df7688e9d6fd45","78":"9d0e7ed4e5745fce730b","79":"86e1b75fdec0e236df7c","80":"7638de1ae2dc9c91a966","81":"fe61ce133be9722e9991","82":"f091432d68a837ce1b85","83":"f711367ab896aad621ea","84":"a3daf76d4fe018ad1908","85":"93cc50ec3efe4ce03bbc","86":"d0214f6409d111cd7dc8","87":"a53031d5556684f98db6","88":"7153db492da5b249d188","89":"eda219bda8bc35f0fe93","90":"5d5ccc350081191965d6","91":"b98d474a00e2ab0e48d3","92":"70c80296d5b1abc8d2bf"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/cfd02e1/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
